module.exports = __webpack_public_path__ + "img/grid-1x2.11ea5b10.svg";